
import { companyStore } from '@/store';
import { format, startOfMonth, endOfMonth, isWithinInterval, startOfDay, endOfDay, subDays } from 'date-fns';
import { pt } from 'date-fns/locale';
import { Component, Prop, Vue } from 'vue-property-decorator';
import FilteredJustMonth from './FilteredJustMonth.vue';
import FilteredCompany from './FilteredCompany.vue';
import FilteredState from './FilteredState.vue';
import FilteredAnswer from './FilteredAnswer.vue';
import { IPerformanceIndicatorAnswer } from '@/interfaces/performance_indicator';

@Component({
  components: {
    FilteredJustMonth,
    FilteredCompany,
    FilteredState,
    FilteredAnswer,
  },
})
export default class Planning extends Vue {
  @Prop({ type: Number, default: '' }) readonly departmentId: number;
  @Prop({ type: Object, default: () => {} }) readonly dptoItems: object;

  goBack() {
    this.$emit('back');
  }

  filterDate = 'total';

  expansion = [
    { id: 1, title: 'Mês' },
    { id: 2, title: 'Escola KNN' },
    { id: 3, title: 'Estado' },
    { id: 4, title: 'Campanha' },
  ];

  get currentMonth() {
    const wordMonth = format(new Date(), 'MMMM', { locale: pt });
    const capitalized = wordMonth[0].toUpperCase() + wordMonth.substring(1);
    return capitalized;
  }

  isToday(date: number | Date) {
    const todayStart = startOfDay(new Date());
    const todayEnd = endOfDay(new Date());
    return isWithinInterval(date, { start: todayStart, end: todayEnd });
  }

  isLastWeek(date: number | Date) {
    const lastWeekStart = startOfDay(subDays(new Date(), 7));
    const todayEnd = endOfDay(new Date());
    return isWithinInterval(date, { start: lastWeekStart, end: todayEnd });
  }

  isLastFifteenDays(date: number | Date) {
    const lastFifteenDaysStart = startOfDay(subDays(new Date(), 15));
    const todayEnd = endOfDay(new Date());
    return isWithinInterval(date, {
      start: lastFifteenDaysStart,
      end: todayEnd,
    });
  }

  isThisMonth(date: number | Date) {
    const monthStart = startOfMonth(new Date());
    const monthEnd = endOfMonth(new Date());
    return isWithinInterval(date, { start: monthStart, end: monthEnd });
  }

  get allItems() {
    const items: IPerformanceIndicatorAnswer = this.dptoItems;

    const dateFilters = {
      // aD = answerDate
      today: (aD: number | Date) => this.isToday(aD),
      lastWeek: (aD: number | Date) => this.isLastWeek(aD),
      lastFifteenDays: (aD: number | Date) => this.isLastFifteenDays(aD),
      total: (aD: number | Date) => this.isThisMonth(aD),
    };

    let filteredAnswers: IPerformanceIndicatorAnswer = {};

    for (const campaign in items) {
      const campaignAnswers = items[campaign].filter((answer: IPerformanceIndicatorAnswer) => {
        const answerDate = new Date(answer.answer_created_at);
        const filterFunction = dateFilters[this.filterDate];
        return filterFunction ? filterFunction(answerDate) : true;
      });

      if (campaignAnswers.length > 0) {
        filteredAnswers[campaign] = campaignAnswers;
      }
    }
    return filteredAnswers;
  }

  async mounted() {
    await companyStore.getCompanies({
      is_active: true,
      is_franchise: true,
    });
  }
}
